export default __webpack_public_path__ + "static/media/iconPlusWhite.bec36c4c.svg";